import(/* webpackMode: "eager", webpackExports: ["Apply"] */ "/workspace/src/components/moleculer/events/suzuka2025/apply.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Contact"] */ "/workspace/src/components/moleculer/events/suzuka2025/contact.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Fee"] */ "/workspace/src/components/moleculer/events/suzuka2025/fee.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FixedEventInfo"] */ "/workspace/src/components/moleculer/events/suzuka2025/fixedEventInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/workspace/src/components/moleculer/events/suzuka2025/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Judges"] */ "/workspace/src/components/moleculer/events/suzuka2025/judges.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Prizes"] */ "/workspace/src/components/moleculer/events/suzuka2025/prizes.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Schedule"] */ "/workspace/src/components/moleculer/events/suzuka2025/schedule.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SectionTitle"] */ "/workspace/src/components/moleculer/events/suzuka2025/sectionTitle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Sponsors"] */ "/workspace/src/components/moleculer/events/suzuka2025/sponsors.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Theme"] */ "/workspace/src/components/moleculer/events/suzuka2025/theme.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WrapperSuzuka2025"] */ "/workspace/src/components/moleculer/events/suzuka2025/wrapperSuzuka2025.tsx");
